import React from "react";

import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import Stack from "@mui/material/Stack";
import igLogo from "@src/images/igLogo/Logo_Lockup_Horiz.png";

type ErrorMessage = { title: string; contents: string };

export interface ShareErrorStateProps {
  errorType:
    | "no-token"
    | "invalid-token"
    | "not-found"
    | "network-error"
    | "no-data";
  errorMessage?: ErrorMessage;
}

const ERROR_MESSAGES: Record<ShareErrorStateProps["errorType"], ErrorMessage> =
  {
    "no-token": {
      title: "No access to this shared link",
      contents:
        "We couldn't verify access for this link. Ask the sender for a new one.",
    },
    "invalid-token": {
      title: "No access to this shared link",
      contents: "This share link is invalid or expired",
    },
    "not-found": {
      title: "No access to this shared link",
      contents: "This experience no longer exists",
    },
    "network-error": {
      title: "No access to this shared link",
      contents: "Unable to load analytics data",
    },
    "no-data": {
      title: "No Data",
      contents: "Unable to load analytics data",
    },
  } as const;

export const ShareErrorState = ({
  errorType,
  errorMessage,
}: ShareErrorStateProps) => {
  const message = errorMessage || ERROR_MESSAGES[errorType];

  return (
    <Stack
      sx={{ width: "100svw", height: "100svh" }}
      justifyContent="center"
      alignItems="center"
    >
      <Stack spacing={4} alignItems="center">
        <img src={igLogo} style={{ width: "100%", maxWidth: "200px" }} />
        <Stack spacing={2}>
          <IgTypography variant="body1" align="center" fontWeight={500}>
            {message.title}
          </IgTypography>
          <IgTypography variant="body2" align="center">
            {message.contents}
          </IgTypography>
        </Stack>
      </Stack>
    </Stack>
  );
};
